import { DonationCard } from 'components/DonationCard'
import { AutoScrollCarousel } from 'components/AutoScrollCarousel'

export const DonationCarousel = ({ cards }) => {
  return (
    <div className="pt-20">
      <AutoScrollCarousel gutter={20} className="aspect-[2/4] md:aspect-video">
        {cards.map((card, index) => {
          return (
            <DonationCard
              key={card._key}
              {...card}
              grid={false}
              className="relative snap-start md:!absolute"
            />
          )
        })}
      </AutoScrollCarousel>
    </div>
  )
}
